export const idFromName = (name: string) => name.replace(/\]/g, '').replace(/[^-a-zA-Z0-9:.]/g, '_')

export function getTestId(testId?: string, suffix?: string) {
  if (!testId) return undefined
  if (!suffix) return testId

  return `${testId}--${suffix}`
}
